import { clearLoginError, loginError } from '../actions'
import { clearSession, isTokenExist, isTokenExpired } from '../utils/session'
import { isResetPasswordPath } from '../utils/routes'
import { API_JWT_TOKEN_NAME } from './api'
import StorageProviderFactory from '../managers/storage_provider_factory'
import { ACTION_LOCATION_CHANGE, STORAGE_TYPE_LOCAL, TRACKED_ACTIONS } from '../config'
import { push } from 'connected-react-router'

const storageProvider = StorageProviderFactory.create(STORAGE_TYPE_LOCAL)

const sessionCheckMiddleware = (store) => (next) => (action) => {
  if (!action) {
    return
  }

  if (action.type === ACTION_LOCATION_CHANGE || TRACKED_ACTIONS.includes(action.type)) {
    const tokenExists = isTokenExist()
    const expired = isTokenExpired()
    const token = storageProvider.getItem(API_JWT_TOKEN_NAME)
    if (!tokenExists || expired) {
      // if user session timed out, message will display on login page for 5 seconds
      if (token) {
        store.dispatch(loginError('Your session has timed out. Please sign in again.'))
        setTimeout(() => store.dispatch(clearLoginError()), 5000)
      }
      clearSession()
      // store.dispatch(tokenExpired())
      const pathname = window.location.pathname
      if (pathname !== '/' && !isResetPasswordPath(pathname)) {
        store.dispatch(
          push({
            pathname: '/',
            state: { redirect_url: pathname },
          })
        )
      }
    }
  }
  if (typeof action.then !== 'function') {
    return next(action)
  }
}

export default sessionCheckMiddleware
